import { render } from "./LanguageChangerFlat.vue?vue&type=template&id=38906d1a&scoped=true"
import script from "./LanguageChangerFlat.vue?vue&type=script&lang=js"
export * from "./LanguageChangerFlat.vue?vue&type=script&lang=js"

import "./LanguageChangerFlat.vue?vue&type=style&index=0&id=38906d1a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38906d1a"]])

export default __exports__